<template>
    <div class="mask-dialog-overlay" v-if="visible" @click="handleOverlayClick">
        <div class="mask-dialog-content" @click.stop>
            <div class="mask-dialog-closeDiv">
                <span class="mask-dialog-close" @click="handleClose">&times;</span>
            </div>
            <div class="modal_short">
                <div>
                    <div class="flex">
                        <div>发布会科技成果名称：{{ item.optimize_name }}</div>
                        <div class="ml50">成果领域：{{ item.scope_str }}</div>
                        <div class="ml50">成果地区：{{ item.org_province_name }}</div>
                    </div>

                    <div class="flex">
                        <div>成果申报名称：{{ item.name }}</div>
                        <div class="ml50">申报单位：{{ item.org_name }}</div>
                    </div>
                    <div class="flex">
                        <div>成果推荐单位：{{ item.orgRec_id_str }}</div>
                    </div>
                </div>
            </div>
            <div class="modal_content">
                {{ item.optimize_profile }}
            </div>

            <div class="modal_shortRed">
                <div class="fontRed" @click="clickFontRed(0)">
                    <div class="mt20">非成果方</div>
                    <div>成果合作服务申请</div>
                </div>
                <div class="fontRed" @click="clickFontRed(1)">
                    <div class="mt20">成果方</div>
                    <div>成果延伸服务申请</div>
                </div>

            </div>

            <div class="formDiv" v-if="showAchieving">
                <div class="formTitle">

                    {{ achieving == 0 ? '非成果方：项目合作服务申请登记表' : '成果方：成果延伸服务申请登记表' }}
                </div>
                <div class="formContent">
                    <div class="tabDiv" v-if="achieving == 0">
                        <div class="tabItem" :class="{ activeTab: activeTab === 1 }" @click="handleTabClick(1)">
                            资本合作</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 2 }" @click="handleTabClick(2)">
                            技术合作</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 3 }" @click="handleTabClick(3)">
                            产业合作</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 4 }" @click="handleTabClick(4)">
                            市场合作</div>

                    </div>
                    <div class="tabDiv" v-if="achieving == 1">
                        <div class="tabItem" :class="{ activeTab: activeTab === 1 }" @click="handleTabClick(1)">
                            精准化供需对接推介活动</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 2 }" @click="handleTabClick(2)">
                            专业化诊断评价策划业务</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 3 }" @click="handleTabClick(3)">
                            数字化云网智能服务平台</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 4 }" @click="handleTabClick(4)">
                            常态化共建科创实体机构</div>
                        <div class="tabItem" :class="{ activeTab: activeTab === 5 }" @click="handleTabClick(5)">
                            生态化落地项目育成工场</div>
                    </div>

                    <div class="tabContent">
                        <el-form label-width="60px" :model="formData" size="small" :rules="rules" ref="loginForm">

                            <div v-if="achieving == 0">
                                <div v-if="activeTab == 1" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目股权投资</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.equity_investment">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目金融信贷
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.financial_credit">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目并购合作
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.merger_acquisition">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目融资代理

                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.financing_agency">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目上市运作

                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.listing_operation">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <div>

                                    </div>

                                </div>

                                <div v-if="activeTab == 2" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>技术专家顾问咨询</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.consulting">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>技术中心合作共建
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.joint_construction">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>技术项目合作研发
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.research_development">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>技术成果转移交易
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.transfer_transaction">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <div>

                                    </div>

                                </div>
                                <div v-if="activeTab == 3" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产业资源供给</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.resource_supply">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产业链条配套
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.chain_matching">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产业园区招商
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.attract_investment">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产业政策扶持
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.policy_support">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>


                                    <div>

                                    </div>

                                </div>
                                <div v-if="activeTab == 4" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>市场战略规划设计</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.plan_design">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产品市场包装宣传
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.packaging_promotion">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>应用场景拓展开发
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.expand_development">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产品销售渠道代理

                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.channel_agent">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>


                                    <div>

                                    </div>

                                </div>


                            </div>
                            <div v-if="achieving == 1">
                                <div v-if="activeTab == 1" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>定向推介活动</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.directional">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>专项推介活动</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.special">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>专题推介活动
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.special_subject">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <div>

                                    </div>

                                </div>

                                <div v-if="activeTab == 2" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目过滤筛选</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.filter">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目对接撮合</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.matchmaking">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目策划促进</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.planning_promotion">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>项目落地平台</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.landing_platform">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <div>

                                    </div>

                                </div>
                                <div v-if="activeTab == 3" class="tabContentDiv">
                                    <el-card class="tabContentThree">
                                        <div slot="header" class="clearfix">
                                            <span>数字化云网智能服务平台</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.digitized_cloud">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>


                                    <div>

                                    </div>

                                </div>
                                <div v-if="activeTab == 4" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>地区合作机构</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.regional">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>行业合作机构</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.industry">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>国际合作机构</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.international">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>


                                    <div>

                                    </div>

                                </div>

                                <div v-if="activeTab == 5" class="tabContentDiv">
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>资本市场投资</span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.capital_market">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>产业园区招商
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.investment_promotion">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>
                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>地区经济产业
                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.economic_industry">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>大型企业重大

                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.large_enterprises">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>

                                    <el-card class="tabContentOne">
                                        <div slot="header" class="clearfix">
                                            <span>中小企业跃升

                                            </span>
                                        </div>
                                        <div>
                                            <el-radio-group v-model="formData.medium_sized">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="2">否</el-radio>
                                            </el-radio-group>
                                        </div>
                                    </el-card>


                                    <div>

                                    </div>

                                </div>
                            </div>

                            <div class="formContentDiv">
                                <el-form-item label="单位:" prop="contacts_org" style="margin-bottom: 25px;">

                                    <el-input v-model="formData.contacts_org" placeholder="请输入你的单位名称"></el-input>
                                </el-form-item>
                                <el-row type="flex" justify="space-between">
                                    <el-col :span="7">
                                        <el-form-item label="职务:" prop="contacts_position">
                                            <el-input v-model="formData.contacts_position"
                                                placeholder="请输入你的职务"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="姓名:" prop="contacts_name">
                                            <el-input v-model="formData.contacts_name" placeholder="请输入你的姓名"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="电话:" prop="contacts_phone">
                                            <el-input v-model="formData.contacts_phone"
                                                placeholder="请输入你的电话"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                            </div>
                            <div
                                style="background-color: #2D3B87;height: 120px;display: flex;justify-content: center;align-items: center;">
                                <el-button size="small" @click="showAchieving = false" round
                                    style="margin-right: 100px;width: 100px;">取消</el-button>
                                <el-button type="primary" size="small" @click="handleSubmit"
                                    round>确认提交延伸服务申请</el-button>
                            </div>

                        </el-form>

                    </div>

                </div>
            </div>
            <div @click="handleClose">
                <img src="../../../assets/closeImg.png" class="mask-dialog-closeImg" alt="">
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'MaskDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            default: () => ({})
        },
        closeOnOverlay: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showAchieving: false,
            achieving: '',
            radio1: '',
            formData: {
                project_item_id: '',
                project_contacts_type: '',
                // 成果方服务 (Tab 1)
                directional: '',             // 定向推介活动
                special: '',                 // 专项推介活动
                special_subject: '',          // 专题推介活动
                // 成果方服务 (Tab 2)
                filter: '',                  // 项目过滤筛选
                matchmaking: '',             // 项目对接撮合
                planning_promotion: '',      // 项目策划促进
                landing_platform: '',        // 项目落地平台
                // 成果方服务 (Tab 3)
                digitized_cloud: '',         // 数字化云网智能服务平台
                // 成果方服务 (Tab 4)
                regional: '',                // 地区合作机构
                industry: '',                // 行业合作机构
                international: '',           // 国际合作机构
                // 成果方服务 (Tab 5)
                capital_market: '',          // 资本市场投资
                investment_promotion: '',    // 产业园区招商
                economic_industry: '',       // 地区经济产业
                large_enterprises: '',       // 大型企业重大
                medium_sized: '',            // 中小企业跃升
                // 资本合作
                equity_investment: '',    // 项目股权投资
                financial_credit: '',     // 项目金融信贷
                merger_acquisition: '',    // 项目并购合作
                financing_agency: '',     // 项目融资代理
                listing_operation: '',    // 项目上市运作
                // 技术合作
                consulting: '',            // 技术专家顾问咨询
                joint_construction: '',   // 技术中心合作共建
                research_development: '', // 技术项目合作研发
                transfer_transaction: '', // 技术成果转移交易
                // 产业合作
                resource_supply: '',      // 产业资源供给
                chain_matching: '',       // 产业链条配套
                attract_investment: '',   // 产业园区招商
                policy_support: '',       // 产业政策扶持
                // 市场合作
                plan_design: '',          // 市场战略规划设计
                packaging_promotion: '',   // 产品市场包装宣传
                expand_development: '',   // 应用场景拓展开发
                channel_agent: '',        // 产品销售渠道代理
                // 成果方服务 (原有字段)
                directional_promotion: '', // 定向推介活动
                project_filter: '',         // 项目过滤筛选
                project_matching: '',       // 项目对接撮合
                project_planning: '',       // 项目策划促进
                project_platform: '',       // 项目落地平台
                digital_platform: '',       // 数字化云网智能服务平台
                regional_cooperation: '',   // 地区合作机构
                industry_cooperation: '',   // 行业合作机构
                international_cooperation: '', // 国际合作机构
                industrial_park: '',        // 产业园区招商
                regional_economy: '',      // 地区经济产业
                large_enterprise: '',      // 大型企业重大
                smes_upgrade: '',          // 中小企业跃升
                // 联系信息
                contacts_org: '',          // 单位
                contacts_position: '',     // 职务
                contacts_name: '',         // 姓名
                contacts_phone: ''         // 电话
            },
            rules: {
                contacts_org: [
                    { required: true, message: '请输入单位名称', trigger: 'blur' }
                ],
                contacts_position: [
                    { required: true, message: '请输入职务', trigger: 'blur' }
                ],
                contacts_name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                contacts_phone: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                ]
            },
            activeTab: 1


        }
    },
    methods: {
        clickFontRed(index) {
            if (this.achieving == index) {
                this.showAchieving = !this.showAchieving

            } else {
                this.showAchieving = true
            }
            this.activeTab = 1
            this.achieving = index
        },
        handleTabClick(tab) {
            this.activeTab = tab
        },
        handleSubmit() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    if (this.item.id) {
                        this.formData.project_item_id = this.item.id
                        this.formData.project_contacts_type = this.achieving == 0 ? 1 : 2
                    }
                    this.formData.cooperate_type = this.achieving == 0?this.activeTab:0
                    this.formData.extend_type=this.achieving==1?this.activeTab:0
                    console.log('表单数据:', this.formData)
                    this.$API.saveProjectContacts(this.formData).then(res => {
                        this.$message.success('提交成功')
                        this.resetForm()
                        this.activeTab = 1
                        this.handleClose()
                    })
                 
                } else {
                    this.$message.error('请填写完整信息')
                    return false
                }
            })
        },
        // 重置表单数据
        resetForm() {
            const keys = Object.keys(this.formData)
            keys.forEach(key => {
                this.formData[key] = ''
            })
            this.$refs.loginForm.resetFields()
        },
        handleOverlayClick() {
            if (this.closeOnOverlay) {
                this.handleClose()
            }
        },
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
::v-deep .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    color: #f5222d !important;
}

::v-deep .el-form-item__error {
    color: #f5222d !important;
}

::v-deep .el-form-item__label {
    color: #000000d9 !important;
}

.formContentDiv {
    width: 700px;
    margin: 20px auto;
}

.clearfix {
    color: 000000d9;
    font-size: 16px;
    font-weight: 500;
}

.ml20 {
    margin-left: 20px;
}

.tabContentDiv {
    display: flex;
    padding-left: 20px;
}

.tabContentThree {
    width: 480px;
    height: 125px;
    background: #fff;
    border-radius: 2px;
    margin-right: 15px;
}

.tabContentOne {
    width: 280px;
    height: 125px;
    background: #fff;
    border-radius: 2px;
    margin-right: 15px;
}

.activeTab {
    color: #1890ff !important;
}

.tabDiv {
    display: flex;
    margin-bottom: 16px;
    border-bottom: 1px solid #fff;
}

.tabItem {
    height: 40px;
    margin: 0 2px 0 0;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border-radius: 4px 4px 0 0;
    -webkit-transition: all .3s cubic-bezier(.645, .045, .355, 1);
    transition: all .3s cubic-bezier(.645, .045, .355, 1);
    font-size: 14px;
    color: #000000a6;
    cursor: pointer;
}

.formContent {
    background: #448EF7;
}

.formTitle {
    text-align: center;
    padding-top: 30px;
    font-size: 30px;
    color: #fff;
    margin-bottom: 20px;
}

.formDiv {
    position: absolute;
    left: 115px;
    top: 130px;
    padding: 0;
    margin: -20px;
    width: 970px;
    height: 540px;
    border-radius: 10px;
    background-color: #2d3b87;
    box-shadow: inset 0 0 5px rgba(5, 17, 236, .5);
    border: 2px solid #a9a9af;
}

.mt20 {
    margin-top: 25px;
}

.fontRed {
    background-image: url('../../../assets/fontRedImg.png');
    width: 302px;
    height: 116px;
    text-align: center;
    font-size: 20px;
    color: #fff;
}

.fontRed:hover {
    background-image: url('../../../assets/fontRedImgHover.png');
}

.modal_content {
    padding-top: 70px;
    margin-left: 115px;
    width: 80%;
    height: 340px;
    overflow: hidden;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
}

.ml50 {
    margin-left: 50px;
}

.modal_shortRed {
    padding-left: 115px;
    display: flex;
    justify-content: space-between;
    padding-right: 115px;

}

.modal_short {
    padding-top: 150px;
    padding-left: 115px;
}

.flex {
    display: flex;
    font-size: 16px;
    line-height: 30px;
    color: #a9a9af;
}

.mask-dialog-closeDiv {
    display: flex;
    justify-content: flex-end;
}

.mask-dialog-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;

}

.mask-dialog-closeImg {
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
}

.mask-dialog-content {
    margin-top: 40px;
    width: 1200px;
    height: 100%;
    background-image: url('../../../assets/2025OneBg.png');
    background-repeat: no-repeat;
    position: relative;
}

.mask-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background: linear-gradient(135deg, #1890FF 0%, #40A9FF 100%);
    color: #fff;
}

.mask-dialog-title {
    font-size: 20px;
    font-weight: bold;
}

.mask-dialog-close {
    font-size: 20px;
    cursor: pointer;
    line-height: 1;
    color: #fff;
}

.mask-dialog-close:hover {
    color: #1890FF;
}

.mask-dialog-body {
    padding: 30px;
    overflow-y: auto;
    flex: 1;
}
</style>
